import React, { useCallback } from 'react';
import { ICard } from './CardsShowOff';
import styles from '../Components.module.css';
import { useSelector } from 'react-redux';
import { IState, IUser } from '../../graphql/types';
import { Card, Tooltip } from 'antd';

interface IFeedCardIcon {
  item: ICard;
  onClick: (item: ICard) => void;
}
const FeedCardIcon: React.FC<IFeedCardIcon> = ({ item, onClick }) => {
  const user = useSelector<IState, IUser | undefined>(state => state.user);

  const isFeatureEnabled = useCallback(
    (item: ICard) => {
      if (!!item.disabled) {
        return false;
      }

      switch (item.title) {
        case 'Poll':
          return !!user?.plan?.features?.pollQuizFeature?.isActive
            ? true
            : null;
        default:
          return true;
      }
    },
    [user]
  );

  return (
    <Tooltip placement="top" title={item.hintText}>
      <Card
        hoverable
        key={item.mockup.type}
        onClick={() => onClick(item)}
        className={`${styles.cardTypeSelectionItem} ${
          !isFeatureEnabled(item) ? styles.cardTypeSelectionItemDisabled : ''
        }`}
      >
        <div>
          <div
            className={`${
              !isFeatureEnabled(item)
                ? styles.cardTypeSelectionItemDisabled
                : ''
            }`}
          >
            <img
              src={item.src}
              alt={item.altText}
              style={!isFeatureEnabled(item) ? { opacity: 0.5 } : {}}
            />
          </div>
          <div
            className={`${
              item.titleNote
                ? styles.cardTypeSelectionItemTitleWNote
                : styles.cardTypeSelectionItemTitle
            } ${
              !isFeatureEnabled(item)
                ? styles.cardTypeSelectionItemTitleDisabled
                : ''
            }`}
          >
            {item.title}
            {isFeatureEnabled(item) === null && (
              <div className={styles.cardTypeSelectionItemTitleNote}>
                (Premium feature)
              </div>
            )}

            {item.titleNote && (
              <div className={styles.cardTypeSelectionItemTitleNote}>
                {item.titleNote}
              </div>
            )}
          </div>
        </div>
      </Card>
    </Tooltip>
  );
};

export default FeedCardIcon;
